import { Address, encodeFunctionData, parseAbi, zeroAddress } from "viem";

export const INCEPTION_FACTORY_ABI = parseAbi([
  "function create(address notificationContract, string ensName, string ensSubdomainName, address ensSubdomainRegistrar, address ensReverseRegistrar) returns (address vaultAddress)",
  "function balanceOf(address owner) view returns (uint256)",
  "function tokenOfOwnerByIndex(address owner, uint256 index) view returns (uint256)",
  "function collectionAddress(uint256 tokenId) view returns (address)",
  "function ownerOf(uint256 tokenId) view returns (address)",
  "function tokenIdForCollection(address collectionAddress) view returns (uint256)",
  "function safeTransferFrom(address from, address to, uint256 tokenId)",
  "event NewCollection(address indexed owner, address collectionAddress)",
]);

export const INCEPTION_VAULT_ABI = parseAbi([
  "function ownerAddress() view returns (address)",
  "function vaultVersion() pure returns (uint256)",
  "function accountVersion() pure returns (uint256)",
  "function authorizeSessionKey(address sessionKey, uint48 validAfter, uint48 validUntil, uint96 maxNativeValuePerCall, uint128 dailyNativeValueLimit, bool canSign)",
  "function revokeSessionKey(address sessionKey)",
  "function sessionKeyCount() view returns (uint256)",
  "function sessionKeyAt(uint256 index) view returns (address sessionKey, (address controller,uint48 validAfter,uint48 validUntil,uint96 maxNativeValuePerCall,uint128 dailyNativeValueLimit,bool canSign) policy, bool active)",
  "function paused() view returns (bool)",
  "function setPaused(bool paused)",
  "function setSessionPermission(address sessionKey, address target, bytes4 selector, bool allowed)",
  "function setSessionTokenPolicy(address sessionKey, address token, uint128 maxAmountPerCall, uint128 dailyAmountLimit, bool allowUnlimitedApproval)",
  "function executeFromSession(address target, uint256 nativeValue, bytes callData) returns (bytes result)",
  "function isValidSignature(bytes32 hash, bytes signature) view returns (bytes4)",
  "function ownedAssetsCount() view returns (uint256)",
  "function ownedAssetAt(uint256 index) view returns (address token, uint256 tokenId)",
  "function withdrawAllNFTs(address to)",
  "function withdrawAllERC20(address token, address to)",
  "function withdrawAllNative(address to)",
  "function externalCall(address remoteAddress, bytes callPayload) payable returns (bytes result)",
  "function approveHash(bytes32 hash)",
  "function revokeHash(bytes32 hash)",
]);

export const ERC20_BALANCE_ABI = parseAbi([
  "function balanceOf(address account) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
]);

export const ERC165_ABI = parseAbi([
  "function supportsInterface(bytes4 interfaceId) view returns (bool)",
]);

export const ERC721_TRANSFER_ABI = parseAbi([
  "function safeTransferFrom(address from, address to, uint256 tokenId)",
]);

export const ERC1155_TRANSFER_ABI = parseAbi([
  "function safeTransferFrom(address from, address to, uint256 tokenId, uint256 amount, bytes data)",
  "function balanceOf(address account, uint256 tokenId) view returns (uint256)",
]);

export const INCEPTION_ERC721_WITHDRAW_ABI = parseAbi([
  "function safeTransferTo(address token, uint256 tokenId, address to)",
]);

export const INCEPTION_ERC1155_WITHDRAW_ABI = parseAbi([
  "function safeTransferTo(address token, uint256 tokenId, address to, uint256 amount)",
]);

const configuredAddress = import.meta.env.VITE_INCEPTION_FACTORY_ADDRESS as string | undefined;

export const INCEPTION_FACTORY_ADDRESS = configuredAddress?.match(/^0x[a-fA-F0-9]{40}$/)
  ? configuredAddress as Address
  : undefined;

export const INCEPTION_CREATE_CALLDATA = encodeFunctionData({
  abi: INCEPTION_FACTORY_ABI,
  functionName: "create",
  args: [zeroAddress, "", "", zeroAddress, zeroAddress],
});

export const ERC721_INTERFACE_ID = "0x80ac58cd" as const;
export const ERC1155_INTERFACE_ID = "0xd9b67a26" as const;
